import BaseApiAction from "@Actions/base-api-action";

export default class GetChallengeResults extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "challenges-getChallengeResults",
      payload: {
        "user_id": this._payload.user_id,
        "challenge_id": this._payload.challenge_id,
      },
    });
  }
}
